import { put, takeEvery } from 'redux-saga/effects';
import {
    GET_FAULTS, GET_FAULT_PHOTOS_AND_VIDEOS, EDIT_FAULT, ADD_FAULT, GET_FAULT_TAGS_DICTIONARY, DELETE_FAULT,
} from './../types/faults';

import {
    getFaultsSuccess,
    getFaultsFail,
    getFaultPhotosAndVideosSuccess,
    getFaultPhotosAndVideosFail,
    editFaultSuccess,
    editFaultFail,
    addFaultSuccess,
    addFaultFail,
    getFaultTagsDictionarySuccess,
    getFaultTagsDictionaryFail,
    deleteFaultSuccess,
    deleteFaultFail
} from './../actions/faults';
import { getBaseUrl } from './../reducers/domainProperties';

const BASE_URL = getBaseUrl();

export function* getFaultsSaga(action) {
    try {
        const { axiosInstance } = action;
        const { data } = yield axiosInstance.get(`${BASE_URL}faults`);
        yield put(getFaultsSuccess(data));
    } catch (error) {
        yield put(getFaultsFail(error));
    }
}

export function* watchGetFaults() {
    yield takeEvery(GET_FAULTS, getFaultsSaga);
}

export function* getFaultPhotosAndVideosSaga(action) {
    try {
        const { axiosInstance } = action;
        const photosResponse = yield axiosInstance.get(`${BASE_URL}faults/${action.faultId}/photos`);
        const videosResponse = yield axiosInstance.get(`${BASE_URL}faults/${action.faultId}/videos`);
        yield put(getFaultPhotosAndVideosSuccess(photosResponse.data, videosResponse.data));
    } catch (error) {
        yield put(getFaultPhotosAndVideosFail(error));
    }
}

export function* watchGetFaultPhotosAndVideos() {
    yield takeEvery(GET_FAULT_PHOTOS_AND_VIDEOS, getFaultPhotosAndVideosSaga);
}

export function* getFaultTagsDictionarySaga(action) {
    try {
        const { axiosInstance } = action;
        const { data } = yield axiosInstance.get(`${BASE_URL}faults/tags`);
        yield put(getFaultTagsDictionarySuccess(data));
    } catch (error) {
        yield put(getFaultTagsDictionaryFail(error));
    }
}

export function* watchGetFaultTagsDictionary() {
    yield takeEvery(GET_FAULT_TAGS_DICTIONARY, getFaultTagsDictionarySaga);
}

export function* editFault(action) {
    try {
        const { axiosInstance, faultFeature } = action;
        const url = `faults/${faultFeature.id}`
        yield axiosInstance.put(url, faultFeature);
        yield put(editFaultSuccess(faultFeature));
    }
    catch (error) {
        yield put(editFaultFail(error));
    }
}

export function* watchEditFault() {
    yield takeEvery(EDIT_FAULT, editFault);
}

export function* addFault(action) {
    try {
        const { axiosInstance, faultFeature } = action;
        const url = "faults";
        const {data} = yield axiosInstance.post(url, faultFeature)
        yield put(addFaultSuccess(data));
    }
    catch (error) {
        yield put(addFaultFail(error));
    }
}

export function* watchAddFault() {
    yield takeEvery(ADD_FAULT, addFault);
}

export function* deleteFault(action) {
    try {
        const { axiosInstance } = action;
        yield axiosInstance.request(
            {
                url: `faults/${action.faultId}`,
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );
        yield put(deleteFaultSuccess(action.faultId));
    }
    catch (error) {
        yield put(deleteFaultFail(error));
    }
}

export function* watchDeleteFault() {
    yield takeEvery(DELETE_FAULT, deleteFault);
}


// WEBPACK FOOTER //
// ./src/sagas/faults.jsx